const _version = "2.5.1"
function version() {
    return _version;
}
export default version
